// Sugalarm — the glucose status pill's shared look (cycle 451.2).
//
// One class pair for every "In range" / "Low" / … pill: <Pill
// appearance="status"> uses it, and the one site that is not a <Pill>
// (NowScreen's bare-hero eyebrow) applies it directly.

import type { PillTone } from "./Pill";
import styles from "./StatusPill.module.css";

export function statusPillClass(tone: PillTone): string {
  return `${styles.status} ${styles[tone]}`;
}
